import { SafiVatEnum } from 'api';
import { CountryAutocompleteField, IncotermSelectField, SelectField, TextField, useFormContext } from 'form';
import { useTranslation } from 'i18n';
import { ChangeEvent, useContext } from 'react';
import { SectionContainer } from 'ui';

import { PurchaseOrderFormContext } from '../../contexts/PurchaseOrderFormContext';
import { CreateFormValues } from '../../pages/PurchaseOrderCreate/PurchaseOrderCreate';
import { selectableIncoterms } from '../../schemas/basePurchaseOrderSchema';

const VAT_OPTIONS = Object.values(SafiVatEnum).map((value) => ({
  label: value,
  value: value,
}));

export const SellerDealDetailsSection = () => {
  const { t } = useTranslation('orders');
  const { t: commonT } = useTranslation('common');
  const { setValue, getValues } = useFormContext<CreateFormValues>();
  const { variant } = useContext(PurchaseOrderFormContext);

  const handleTonnesPerLoadChange = (e: ChangeEvent<HTMLInputElement>) => {
    const numberOfLoads = getValues('number_of_loads');
    setValue('tonnes', String(Number(e.target.value) * Number(numberOfLoads)));
  };

  const handleNumberOfLoadsChange = (e: ChangeEvent<HTMLInputElement>) => {
    const tonnesPerLoad = getValues('tonnes_per_load');
    setValue('tonnes', String(Number(e.target.value) * Number(tonnesPerLoad)));
  };

  return (
    <SectionContainer title={t('sellerDealDetailsSection.title')}>
      <IncotermSelectField
        selectableIncoterms={selectableIncoterms}
        infoTooltip={t('sellerDealDetailsSection.incotermTooltip')}
      />
      <TextField
        name="tonnes_per_load"
        label={t('sellerDealDetailsSection.tonnesPerLoadLabel')}
        type="number"
        required
        infoTooltip={t('sellerDealDetailsSection.tonnesPerLoadTooltip')}
        onChange={handleTonnesPerLoadChange}
      />
      <TextField
        label={t('sellerDealDetailsSection.numberOfLoadsLabel')}
        name="number_of_loads"
        type="number"
        required
        infoTooltip={t('sellerDealDetailsSection.numberOfLoadsTooltip')}
        onChange={handleNumberOfLoadsChange}
      />

      {variant === 'create' ? (
        <CountryAutocompleteField
          label={t('sellerDealDetailsSection.finalDestinationCountryLabel')}
          name="final_destination_country"
          required
        />
      ) : null}
      {variant === 'update' ? (
        <SelectField name="safi_vat" label={commonT('brand.vatLabel')} options={VAT_OPTIONS} required />
      ) : null}
      <TextField
        type="number"
        name="tonnes"
        label={t('sellerDealDetailsSection.numberOfTonnesLabel')}
        disabled
        infoTooltip={t('sellerDealDetailsSection.numberOfTonnesTooltip')}
      />
    </SectionContainer>
  );
};
